import { ComposedChart } from "recharts";

const BaseComposedChart = (props)=>{
    return <ComposedChart {...props}>
        {props.children}
    </ComposedChart>
}

export default BaseComposedChart;